import { provideState } from '@ngrx/store';

import { userReducer } from './reducer';
import { userFeatureKey } from './state';

export function provideUser() {
    return [provideState(userFeatureKey, userReducer)];
}
